(function () {
  'use strict';

  // When a breast pump is added to the cart, silently add the free 100-pack
  // of disposable milk bags first, so the pump request's re-rendered cart
  // sections already include them. Pricing (making the bags £0) is handled
  // by the "Free Disposable Bags with Breast Pump" automatic discount in
  // Shopify admin — this script only puts the bags in the cart.
  var TRIGGER_VARIANT_IDS = [
    56129993113982, // BABYGO® Air™ Electric Breast Pump (single)
    56130019885438  // BABYGO® Double Air™ Electric Breast Pump
  ];
  var BAG_VARIANT_ID = 56293449466238; // Disposable Breast Milk Storage Bags — 100 pack

  var originalFetch = window.fetch;

  function addedVariantIds(input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf('/cart/add') === -1) return null;

      var body = init && init.body;
      var ids = [];

      if (body instanceof FormData) {
        body.forEach(function (value, key) {
          if (key === 'id' || /^items\[\d+\]\[id\]$/.test(key)) {
            ids.push(parseInt(value, 10));
          }
        });
      } else if (typeof body === 'string') {
        try {
          var parsed = JSON.parse(body);
          if (parsed.id) ids.push(parseInt(parsed.id, 10));
          (parsed.items || []).forEach(function (item) {
            ids.push(parseInt(item.id, 10));
          });
        } catch (jsonError) {
          var match = body.match(/(?:^|&)id=(\d+)/);
          if (match) ids.push(parseInt(match[1], 10));
        }
      }
      return ids;
    } catch (e) {
      return null;
    }
  }

  function ensureBagsInCart() {
    return originalFetch
      .call(window, '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var hasBags = cart.items.some(function (item) {
          return item.variant_id === BAG_VARIANT_ID;
        });
        if (hasBags) return null;
        return originalFetch.call(window, '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: [{ id: BAG_VARIANT_ID, quantity: 1 }] })
        });
      })
      .catch(function (e) {
        console.warn('[auto-add-bags] Could not add bags:', e);
      });
  }

  window.fetch = function (input, init) {
    var ids = addedVariantIds(input, init);
    var isPumpAdd =
      ids &&
      ids.some(function (id) {
        return TRIGGER_VARIANT_IDS.indexOf(id) !== -1;
      });

    if (!isPumpAdd) return originalFetch.apply(this, arguments);

    var self = this;
    var args = arguments;
    return ensureBagsInCart().then(function () {
      return originalFetch.apply(self, args);
    });
  };
})();
